<template>
  <v-dialog max-width="650" v-model="dialog" @keydown.enter.prevent="onenter">
    <v-card>
      <v-card-title>
        <span class="headline">Treasure Bundle ({{ this.rules.name }})</span>
      </v-card-title>
      <v-card-text>
        <v-row dense class="mb-4">
          <v-col cols="12" md="12" sm="12">
            <v-text-field disabled label="UID:" v-model.trim="model.uid" hide-details outlined dense/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <r-smart-offer-bundle-treasure-type :model.sync="model.type" label="Type"/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
              label="Name"
              v-model.trim="model.name"
              v-ascii-only
            />
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
              label="Key"
              v-model.trim="model.key"
              v-ascii-only
            />
          </v-col>
        </v-row>
        <v-expansion-panels>
          <r-guard-panel :model.sync="model.guard" title="Guard Config"/>
          <r-guard-money-panel :model.sync="model.guardMoney" title="Guard Money"/>
        </v-expansion-panels>
        <v-row dense class="mt-3">
          <v-col cols="12" md="5" sm="5" v-if="product_groups.length > 0">
            <r-product-dropdown :model.sync="model.playProduct" :groups="product_groups" label="Play Product"/>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-checkbox v-model="model.bonusUnlimited" label="Bonus Unlimited" hide-details/>
          </v-col>
        </v-row>
        <v-row dense class="mt-3">
          <v-col cols="12" md="5" sm="5">
            <v-autocomplete
                v-model="model.areYouSureType"
                :items="are_you_sure"
                item-text="name"
                item-value="id"
                label="Are you sure (type)"/>
          </v-col>
        </v-row>
        <v-row dense class="pt-6">
          <v-expansion-panels>
            <r-treasure-level-config-panel :items.sync="model.basicLevels" title="Basic Levels"/>
            <r-treasure-level-config-panel :items.sync="model.bonusLevels" title="Bonus Levels"/>
            <r-currency-panel :items.sync="model.continuePrice" title="Continue Price"/>
            <r-reward-panel :model.sync="model.winReward" title="Win Reward"/>
            <r-treasure-lower-cap-config-panel :model.sync="model.lowerCapConfig" title="Lower Cap"/>
          </v-expansion-panels>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {ProductGroupKind} from "@/modules/redactor/models/product/ProductGroupKind";
import {SmartOfferBundleTreasure} from "@/modules/redactor/models/smart-offer/bundle-treasure/SmartOfferBundleTreasure";

import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel.vue";
import RGuardMoneyPanel from "@/modules/redactor/views/guard/r-guard-money-panel.vue";
import RSmartOfferBundleTreasureType from "@/modules/redactor/views/smart-offer/bundle-treasure/r-smart-offer-bundle-treasure-type.vue";
import RRewardPanel from "@/modules/redactor/views/reward/r-reward-panel.vue";
import RProductDropdown from "@/modules/redactor/views/product/r-product-dropdown.vue";
import RCurrencyPanel from "@/modules/redactor/views/currency/r-currency-panel.vue";
import RTreasureLevelConfigPanel from "@/modules/redactor/views/smart-offer/bundle-treasure/r-treasure-level-config-panel.vue";
import RTreasureLowerCapConfigPanel from "@/modules/redactor/views/smart-offer/bundle-treasure/r-treasure-lower-cap-config-panel.vue";


export default {
  name: "r-smart-offer-bundle-treasure",
  components: {RTreasureLowerCapConfigPanel, RTreasureLevelConfigPanel, RCurrencyPanel, RProductDropdown, RRewardPanel, RSmartOfferBundleTreasureType, RGuardMoneyPanel, RGuardPanel},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    tab: null,
    model: new SmartOfferBundleTreasure(),
    rules: ViewRules.READONLY
  }),
  computed: {
    product_groups() {
      return [ProductGroupKind.SMART_OFFERS];
    },
    are_you_sure() {
      return [{id: 0, name: "DEFAULT"}, {id: 1, name: "IMPROVED"}];
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.tab = null;
      this.rules = rules;
      this.model = model || new SmartOfferBundleTreasure();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    onenter() {
      this.save();
    }
  }
}
</script>
